import { trackPromise } from 'react-promise-tracker'
import { parseResponse } from '@jweb-development/response-parser'
import {
  GET_USER_GENERAL_SETTINGS, SET_PAGE_CAPTURE_LIMIT, SET_PAGE_VIEW, GET_ORG_CONTACTS, GET_ORG_GENERAL_SETTINGS,
  GET_ORG_LICENSE_SETTINGS, GET_ORG_EMAIL_SETTINGS, GET_ORG_SETTINGS, GET_USER_ROLE_SETTINGS,
  GET_USER_PERMISSIONS, GET_USER_ROLE_SUPERVISORS, GET_AUP_LIST, GET_CATEGORIES, GET_ACTIONS, GET_INTEGRATION_SETTINGS
} from '../types'

const api = (() => {
  if ((process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:') {
    return 'http://' + window.location.hostname + ':3080'
  }

  if ((process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:') {
    return 'https://' + window.location.hostname + ':8443'
  }

  return process.env.REACT_APP_API_URL
})()

const defaultIntegrationSettings = {
  summary: {
    settingID: '',
    accountID: '',
    organizationID: '',
    apiKey: '',
    apiSecret: '',
    createdBy: '',
    createdAt: 0,
    disabledBy: '',
    disabledAt: 0,
    enabled: false,
    enabledAt: 0,
    setupType: 'S'
  },
  units: {}
}

export const initiateLearnsafe = (fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId: accountID } = getState().auth

      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/initLS`, options))
      const parsedResponse = parseResponse(response)

      if (typeof parsedResponse === 'object' && !parsedResponse.error) {
        const { data: { accountInfo, ciscoInfo, options, supervisorInfo } = {} } = await response.json()

        if (typeof supervisorInfo === 'object' && Boolean(supervisorInfo.supervisorID)) {
          const {
            firstName, lastName, jobTitle, cellPhone, officePhone, emailAddress, samePhone, enableSMS,
            defaultPage, defaultReport, defaultView, defaultCaptureCount, avatarKey, avatarPath
          } = supervisorInfo

          const userSettings = {
            firstName,
            lastName,
            jobTitle,
            cellPhone,
            officePhone,
            emailAddress,
            samePhone,
            enableSMS,
            defaultPage,
            defaultReport,
            defaultView,
            defaultCaptureCount,
            avatarKey,
            avatarPath
          }

          dispatch({ type: GET_USER_GENERAL_SETTINGS, payload: userSettings })

          dispatch({ type: SET_PAGE_CAPTURE_LIMIT, payload: defaultCaptureCount })

          dispatch({ type: SET_PAGE_VIEW, payload: defaultPage })
        }

        if (
          typeof accountInfo === 'object' && Boolean(accountInfo.accountID) &&
          typeof options === 'object' && Array.isArray(options.availableContacts)
        ) {
          const { adminSupervisor = '', billingSupervisor = '', technicalSupervisor = '' } = accountInfo.currentContacts
          const orgContacts = { adminSupervisor, billingSupervisor, technicalSupervisor, availableContacts: options.availableContacts }

          dispatch({ type: GET_ORG_CONTACTS, payload: orgContacts })

          const {
            accountName = '', address = '', address2 = '', city = '', state = '', postalCode = '',
            timeZone = '', primaryColor = '', secondaryColor = '', imageKey = '', imagePath = '',

            welcomeEmailTemplate = '', alertEmailTemplate = '', sourceEmailAddress = '', sourceEmailName = '',

            defaultAUP = '', aupName = '', authenticationMethod = '', disableAgents = 0,
            enableWebLog = 0, enableSMS = 0, enableLSAlerts = 1
          } = accountInfo

          const orgSettings = {
            accountName,
            address,
            address2,
            city,
            state,
            postalCode,
            timeZone,
            primaryColor,
            secondaryColor,
            imageKey,
            imagePath
          }

          dispatch({ type: GET_ORG_GENERAL_SETTINGS, payload: orgSettings })

          const { beginsAt = 0, expiresAt = 0, createdAt = 0, maxUserCount = 0, activeUserCount = 0 } = accountInfo.licenseInfo
          const orgLicense = { beginsAt, expiresAt, createdAt, maxUserCount, activeUserCount }

          dispatch({ type: GET_ORG_LICENSE_SETTINGS, payload: orgLicense })

          const orgEmails = {
            welcomeEmailTemplate: JSON.parse(welcomeEmailTemplate),
            alertEmailTemplate: JSON.parse(alertEmailTemplate),
            sourceEmailAddress,
            sourceEmailName
          }

          dispatch({ type: GET_ORG_EMAIL_SETTINGS, payload: orgEmails })

          const orgAupSettings = {
            defaultAUP, aupName, authenticationMethod, disableAgents, enableWebLog, enableSMS, enableLSAlerts
          }

          dispatch({ type: GET_ORG_SETTINGS, payload: orgAupSettings })
        }

        if (typeof options === 'object' && Array.isArray(options.roles)) {
          dispatch({ type: GET_USER_ROLE_SETTINGS, payload: options.roles })
        }

        if (typeof options === 'object' && Array.isArray(options.permissions)) {
          dispatch({ type: GET_USER_PERMISSIONS, payload: options.permissions })
        }

        if (typeof options === 'object' && Array.isArray(options.roleSupervisors)) {
          dispatch({ type: GET_USER_ROLE_SUPERVISORS, payload: options.roleSupervisors })
        }

        if (typeof options === 'object' && Array.isArray(options.aups)) {
          const mappedAups = options.aups.reduce((arr, aupInfo) => {
            if (aupInfo && aupInfo.aupHTML) {
              const { aupHTML = '' } = aupInfo
              arr.push({ ...aupInfo, aupHTML: JSON.parse(aupHTML) })
            }
            return arr
          }, [])

          dispatch({ type: GET_AUP_LIST, payload: mappedAups })
        }

        if (typeof options === 'object' && Array.isArray(options.categories)) {
          dispatch({ type: GET_CATEGORIES, payload: options.categories })
        }

        if (typeof options === 'object' && Array.isArray(options.actions)) {
          dispatch({ type: GET_ACTIONS, payload: options.actions })
        }

        if (typeof ciscoInfo === 'object' && typeof ciscoInfo.settings === 'object') {
          const { settings: integrations = defaultIntegrationSettings, unitDestinations = {}, domains: restrictedDomains = [], requests: blockRequests = {} } = ciscoInfo

          dispatch({ type: GET_INTEGRATION_SETTINGS, payload: { settings: integrations, unitDestinations, restrictedDomains, blockRequests } })
        }

        return fireSuccess()
      } else {
        return fireFailure()
      }
    } catch (err) {
      console.log(err)
      return fireFailure()
    }
  }
}
